
namespace Gamification.Gamification {
    export class UtentiProdottiAlertColumns {
        static columnsKey = 'Gamification.UtentiProdottiAlert';
    }
}